import { render, staticRenderFns } from "./AdminTierForm.vue?vue&type=template&id=b7f5961a&"
import script from "./AdminTierForm.vue?vue&type=script&lang=js&"
export * from "./AdminTierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports